export const CART_ID_COOKIE = 'cartId';
export const SESSION_ID_COOKIE = 'sessionId';
export const OTO_ORDERS_COOKIE = 'otoOrders';
export const OTO_TOKEN_COOKIE = 'otoToken';